import { render, staticRenderFns } from "./Funcao.vue?vue&type=template&id=9f5c1ce6"
import script from "./Funcao.vue?vue&type=script&lang=js"
export * from "./Funcao.vue?vue&type=script&lang=js"
import style0 from "./Funcao.vue?vue&type=style&index=0&id=9f5c1ce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports